import * as React from "react";
import DataGrid from "../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import AssetAttribute from "../../../model/assetAttribute/AssetAttribute";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

interface IProps {
	/**
	 * Asset attributes
	 */
	assetAttributes: AssetAttribute[];
	/**
	 * On select callback.
	 * @param {string[]} headers
	 */
	onSelect: (headers: string[]) => void;
	/**
	 * On import callback.
	 * @param {string} header
	 */
	onImport: (header: string) => void;
	/**
	 * Selected items headers holder
	 */
	selectedItemsHeaders: string[];
}

export default class ManageAssetsTable extends React.Component<IProps> {

	constructor(props: IProps) {
		super(props);
		this.onAllChange = this.onAllChange.bind(this);
	}

	render() {
		return (
			<DataGrid>
				<thead>
				<tr>
					<th style={{width: '84px'}}>
						<Checkbox checked={this.areAllSelected()}
								  onChange={this.onAllChange}/>
					</th>
					<th>Name</th>
					<th style={{width: '500px'}}>Actions</th>
				</tr>
				</thead>
				<tbody>
				{this.props.assetAttributes.map((item, index) =>
					<tr key={index}>
						<td>
							<Checkbox checked={this.isItemSelected(item)}
									  onChange={() => this.onItemChange(item)}/>
						</td>
						<td>{item.label}</td>
						<td>
							<ButtonPrimary onClick={() => this.props.onImport(item.header)}
										   label={"Import"}
										   variant={"burgundy"}/>
						</td>
					</tr>
				)}
				</tbody>
			</DataGrid>
		)
	}

	isItemSelected(item: AssetAttribute) {
		return this.props.selectedItemsHeaders.indexOf(item.header) > -1;
	}

	onItemChange(item: AssetAttribute) {
		let selectedItemsHeaders: string[];
		if (this.isItemSelected(item)) {
			selectedItemsHeaders = [...this.props.selectedItemsHeaders.filter(i => i !== item.header)];
		}
		else {
			selectedItemsHeaders = [...this.props.selectedItemsHeaders.concat(item.header)];
		}
		this.props.onSelect(selectedItemsHeaders);
	}

	areAllSelected() {
		return this.props.assetAttributes.length === this.props.selectedItemsHeaders.length;
	}

	onAllChange() {
		let selectedItemsHeaders: string[];
		if (this.areAllSelected()) {
			selectedItemsHeaders = [];
		}
		else {
			selectedItemsHeaders = this.props.assetAttributes.map(item => item.header);
		}
		this.props.onSelect(selectedItemsHeaders);
	}
}